/**
 * Sprint 156 — ¿Hay que pedirle al dueño que reinicie la computadora de la caja?
 *
 * Las versiones del programa de la caja anteriores a la 1.150.0 bajan una actualización pero
 * sólo la instalan al cerrarse, y esa computadora no se apaga nunca: la mejora se queda esperando
 * para siempre. A partir de la 1.150.0 se instalan solas de madrugada, así que este aviso sólo hace
 * falta **una vez por caja**: para cruzar ese umbral.
 *
 * Dos condiciones, las dos necesarias:
 *  1. Que ya esté publicada una versión que sepa instalarse sola. Pedir un reinicio sin nada que
 *     instalar es hacer trabajar a alguien para nada, y enseña a ignorar el aviso.
 *  2. Que alguna caja que responde tenga una versión anterior. Una apagada no cuenta: de ésa ya
 *     avisa la barra de "no están saliendo los tickets".
 */

/** Primera versión del programa de la caja que se instala sola de madrugada. */
export const VERSION_QUE_SE_INSTALA_SOLA = '1.150.0';

/** Compara `1.84.4` con `1.150.0` como números, no como texto ("84" > "150" en texto). */
export function versionAnterior(a: string, b: string): boolean {
  const pa = a.split('.').map((n) => Number.parseInt(n, 10) || 0);
  const pb = b.split('.').map((n) => Number.parseInt(n, 10) || 0);
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const x = pa[i] ?? 0;
    const y = pb[i] ?? 0;
    if (x !== y) return x < y;
  }
  return false;
}

export function cajaPorReiniciar(
  agentes: Array<{ conectado: boolean; versionAgente: string | null }>,
  versionPublicada: string | null,
): boolean {
  if (!versionPublicada || versionAnterior(versionPublicada, VERSION_QUE_SE_INSTALA_SOLA)) {
    return false;
  }
  return agentes.some(
    (a) =>
      a.conectado &&
      a.versionAgente !== null &&
      versionAnterior(a.versionAgente, VERSION_QUE_SE_INSTALA_SOLA),
  );
}
